import { render, staticRenderFns } from "./StaffHistory.vue?vue&type=template&id=61af8ed2&"
import script from "@/scripts/adminManager/staffHistory.js?vue&type=script&lang=js&"
export * from "@/scripts/adminManager/staffHistory.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports